const OEmbedTypes = Object.freeze({
  PHOTO: 'photo',
  VIDEO: 'video',
  LINK: 'link',
  RICH: 'rich'
});
export default OEmbedTypes;